export default {
  title: 'Cronologia modifiche menu',
  subtitle: 'Visualizza chi ha modificato prezzi, disponibilità e visibilità per {{company}} — e quando.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Tutti gli elementi',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Quando',
    who: 'Modificato da',
    type: 'Tipo',
    item: 'Elemento',
    event: 'Evento',
    changes: 'Modifiche',
  },
  types: {
    product: 'Prodotto',
    modifier: 'Modificatore',
    category: 'Categoria',
    modifier_group: 'Gruppo di modificatori',
    menu: 'Menu',
  },
  events: {
    created: 'Creato',
    updated: 'Aggiornato',
    deleted: 'Eliminato',
  },
  fields: {
    name: 'Nome',
    description: 'Descrizione',
    price: 'Prezzo',
    is_available: 'Disponibilità',
    is_visible: 'Visibilità',
    is_available_for_pickup: 'Disponibilità asporto',
    is_available_for_delivery: 'Disponibilità consegna',
    tax_category_id: 'Categoria fiscale',
    schedule: 'Orari di visualizzazione',
    is_required: 'Obbligatorio',
    max_count: 'Massimo di scelte',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Prezzo per il ritiro',
    delivery: 'Prezzo per la consegna',
    dine_in: 'Prezzo per il consumo in sede',
    room_service: 'Prezzo per il servizio in camera',
  },
  booleans: {
    on: 'Disponibile',
    off: 'Non disponibile',
    yes: 'Sì',
    no: 'No',
  },
  schedule: {
    always: 'Sempre',
    every_day: 'Ogni giorno',
  },
  pagination: {
    previous: 'Precedente',
    next: 'Successivo',
  },
  causers: {
    undo: 'Annulla',
    orders_terminal: 'Terminale ordini',
    approved_by: {
      amigo: 'Amigo, approvato da {{name}}',
      assistant: 'Assistente, approvato da {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Apri nel log di Amigo',
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Caricamento cronologia modifiche menu fallito',
  },
};
